/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TSaveRealtorReportRequest, TSaveRealtorReportModel, IMappers, TSaveRealtorReportResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IUrlResponse } from '../../entities/url_response/UrlResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createSaveRealtorReportModel(parameters: TSaveRealtorReportRequest): TSaveRealtorReportModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'price-estimator',
    pathApi: '/v2/save-realtor-report/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface ISaveRealtorReportOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TSaveRealtorReportRequest;
}

export async function fetchSaveRealtorReport<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ISaveRealtorReportOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TSaveRealtorReportResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createSaveRealtorReportModel(parameters),
    config,
  )) as FetchResponse<TSaveRealtorReportResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IUrlResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TSaveRealtorReportResponse>;
}
